import React from 'react';
import { useState, useEffect } from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();
  const [versionInfo, setVersionInfo] = useState({
    text: 'Version: (Local Development)',
    show: true
  });

  useEffect(() => {
    fetch('/version.txt')
      .then(response => {
        if (!response.ok) {
          console.debug('Version file not found:', response.status)
          return null
        }
        const contentType = response.headers.get('content-type')
        if (!contentType?.includes('text/plain')) {
          console.debug('Invalid content type:', contentType)
          return null
        }
        return response.text()
      })
      .then(text => {
        if (text?.trim()) {
          setVersionInfo({
            text: `Version: ${text.trim()}`,
            show: true
          })
        }
        // if text is null/empty, keep default state
      })
      .catch((error) => {
        console.debug('Error loading version:', error.message)
        setVersionInfo(prev => ({ ...prev, show: false }))
      })
  }, [])
  
  return (
    <footer className="fixed bottom-0 left-0 right-0 z-40 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 py-2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-sm text-gray-600 dark:text-gray-400">
          &copy; {currentYear} Orgadoro
          {versionInfo.show && (
            <span className="d-none d-sm-inline">
              <span className="mx-2">|</span>
              <span>{versionInfo.text}</span>
            </span>
          )}
        </p>
      </div>
    </footer>
  );
}

export default Footer;